<template>
  <g>
    <line x1="0" y1="0" stroke="grey" stroke-width="2"
      v-bind:x2="dstX"
      v-bind:y2="dstY" />
    <line x1="0" y1="0" stroke="grey" stroke-opacity="0" stroke-width="20"
      v-bind:x2="dstX"
      v-bind:y2="dstY"
      v-on:contextmenu.prevent="requestContextmenu($event)" />
  </g>
</template>

<script>
  import Vue from 'vue'
  import EventHub from './EventHub'
  Vue.use(EventHub);

  export default {
    props: {
      dstX: Number,
      dstY: Number,
      childId: String
    },
    computed: {
      transform: function () {
        return 'translate(' + this.srcX + ',' + this.srcY + ')'
      }
    },
    methods: {
      requestContextmenu: function (event) {
        this.$eventHub.$emit('cable-contextmenu-requested', this.childId, event);
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>